<template>
  <v-row no-gutters class="std-container-shadow">
    <v-col cols="12"
           style="font-size: 1.25rem;"
           :style="{backgroundColor: this.color}"
           class="std-header-container d-flex justify-center align-center
                               std-border-top-radius">
      {{title}}
    </v-col>
    <v-col cols="12"
           class="hmc-content-container">
      <v-row no-gutters>
        <v-col cols="4"
               class="d-flex justify-center align-center">
          <div class="img-container pa-0">
            <v-img height="100%"
                   contain
                   :src="img">
            </v-img>
          </div>
        </v-col>
        <v-col cols="8">
          <v-row no-gutters
                 class="pr-8 std-text-blue-3">
            <v-col cols="12"
                   class="hmc-counter-container d-flex ">
              <div class="col-6 pa-0 d-flex align-center justify-center font-weight-medium">{{getFormatNumber(fstCounter)}}</div>
              <div class="col-5 pa-0 d-flex align-center std-text-md pl-3">
                {{fstText}}
              </div>
            </v-col>
            <div class="hmc-break"></div>
            <v-col cols="12"
                   class="hmc-counter-container d-flex">
              <div class="col-6 pa-0 d-flex align-center justify-center font-weight-medium">{{getFormatNumber(sndCounter)}}</div>
              <div class="col-5 pa-0 d-flex align-center std-text-md pl-3">
                {{sndText}}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
    export default {
        name: "HomeMediumCard",
        props: ['img', 'color', 'fstText', 'sndText', 'fstCounter', 'sndCounter', 'title'],
        methods: {
            getFormatNumber(number) {
                if (number < 10) {
                    return '00' + number;
                } else if (number < 100) {
                    return '0' + number;
                } else {
                    return number;
                }
            },
        }
    }
</script>

<style scoped>
  .hmc-content-container {
    height: 204px;
  }

  .img-container {
    height: 116px;
  }

  .hmc-counter-container {
    height: 101px;
    font-size: 4rem;
  }

  .hmc-break {
    background-color: #979797;
    height: 2px;
    width: 100%;
  }


</style>